import {
    customColumnProps,
    DynamicTable,
} from "@maherunlocker/custom-react-table";
import React from "react";
import { useTranslation } from "react-i18next/";
import { useSnapshot } from "valtio";
import { ToastContainer } from "react-toastify";

import {
    setActions,
    setDataZone,
    setIsActionsClicked,
    setIsEdited,
    setValidationAction,
    store,
} from "./store";

import CustomIcons from "./CustomIcons";
import CustomSideFilter from "./CustomSideFilter";
import ZoneForm from "./ZoneForm";

import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";
import { useCallbackPrompt } from "@hooks/useCallbackPrompt";
import { useSelector } from "react-redux";

export default function Zone({
    dataLivraison,
    selectedRowShops,
    data,
    setData,
    setDataLivraison,
}: any) {
    const { t } = useTranslation();
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [selectedRows, setSelectedRows] = React.useState<any>({});

    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );

    const [
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
    ] = React.useState<boolean>(false);
    const [
        isAddNewDeviseButtonClicked,
        setIsAddNewDeviseButtonClicked,
    ] = React.useState(false);

    const {
        isActionsClicked,
        isEdited,
        actions,
        validationAction,
    } = useSnapshot(store);
    const [isAddZone, setIsAddZone] = React.useState(false);

    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
        isEdited
    );
    let schema: any = useSelector(
        (state: any) => state.global.entityDetails.franchise_schema
    );
    let listTva: any[];
    function list() {
        let list: any[] = [];
        for (let el of selectedRowShops[0]["list Of VatRate"]) {
            list.push(el.value);
        }
        return list;
    }
    listTva = list();
    const urlApi = `${process.env.REACT_APP_API_V2_URL}/settings/list/zone/c&c?schema=${schema}&shopId=${selectedRowShops[0].id_boutique_order}`;
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: 999,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    e={e}
                    setSelectedRows={setSelectedRows}
                    setIsAddZone={setIsAddZone}
                    selectedRowShops={selectedRowShops}
                    setDataIsUpdated={setDataIsUpdated}
                    isAddZone={isAddZone}
                    dataLivraison={dataLivraison}
                />
            ),
            disableFilter: false,
        },
        {
            indexOFColumn: 0,
            columnName: t("Country"),
            customJsx: (e: any) => {
                return (
                    <span className="preview-text">
                        {selectedRowShops[0]["Country shop"]}
                    </span>
                );
            },
        },
        {
            indexOFColumn: 3,
            columnName: t("Tva"),
            customJsx: (e: any) => {
                return (
                    <span className="preview-text">
                        {listTva.includes(`${e.selectedRow[t("Tva")]}`)
                            ? `${e.selectedRow[t("Tva")]}`
                            : "0"}
                    </span>
                );
            },
        },
    ];
    React.useEffect(() => {
        if (i18nextLng === "fr" || i18nextLng === "en") {
            setDataIsUpdated(true);
        }
    }, [i18nextLng]);
    React.useEffect(() => {
        setDataZone(data);
    }, [data]);
    React.useEffect(() => {
        setActions(confirmNavigation);
        setIsActionsClicked(showPrompt as boolean);
        setValidationAction(cancelNavigation);
    }, [showPrompt, confirmNavigation, cancelNavigation]);

    return (
        <React.Fragment>
            <div
                style={{
                    display: "grid",
                    minHeight: "350px",
                    gridTemplateColumns: isAddZone ? "2fr 1fr " : "auto",
                    gridColumnGap: "4px",
                    border: 0,
                }}
            >
                <DynamicTable
                    url={urlApi}
                    showFilter
                    canSelect={true}
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    actionColumn={() => <></>}
                    arrayOfCustomColumns={arrayOfCustomColumns}
                    setData={setData}
                    requestHeader={{ "Accept-Language": i18nextLng }}
                    customJsxSideFilterButton={
                        <CustomSideFilter
                            setIsAddZone={setIsAddZone}
                            isAddZone={isAddZone}
                            setLocalFilterActive={setLocalFilterActive}
                            setSelectedRows={setSelectedRows}
                            setIsInInitializationModalOpened={
                                setIsInInitializationModalOpened
                            }
                            isEdited={isEdited}
                            selectedRows={selectedRows}
                        />
                    }
                    showGlobalFilter
                    canExpand
                    elevationTable={1}
                    minHeight={"460px"}
                    maxHeight={"460px"}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                    setSelectedRows={setSelectedRows}
                    name="Choice"
                />
                {isAddZone ? (
                    <ZoneForm
                        isAddZone={isAddZone}
                        setIsAddZone={setIsAddZone!}
                        setDataIsUpdated={setDataIsUpdated}
                        setLocalFilterActive={setLocalFilterActive}
                        isAddNewDeviseButtonClicked={
                            isAddNewDeviseButtonClicked
                        }
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                        selectedRowShops={selectedRowShops}
                        list={listTva}
                        dataLivraison={dataLivraison}
                        setDataLivraison={setDataLivraison}
                    />
                ) : null}
                {isActionsClicked === true ? (
                    <ConfirmationUpdatingDataMessageModal
                        isModalOpened={isActionsClicked}
                        setIsModalOpened={setIsActionsClicked}
                        validationAction={validationAction}
                        actions={actions}
                        setIsEdited={setIsEdited}
                    />
                ) : null}
                {isInInitializationModalOpened === true ? (
                    <ConfirmationInitializationMessage
                        isModalOpened={isInInitializationModalOpened}
                        setIsModalOpened={setIsInInitializationModalOpened}
                        setIsClicked={setIsAddNewDeviseButtonClicked}
                        isClicked={isAddNewDeviseButtonClicked}
                        setIsEdited={setIsEdited}
                    />
                ) : null}
                <ToastContainer limit={1} />
            </div>
        </React.Fragment>
    );
}
